import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

const ShirtIcon = ({ color = '#0D84FE', size = '14px', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    viewBox="0 0 22 16"
    {...props}
  >
    <path
      d="M21.467 3.554C19.275 2.418 15.799.264 14.995 0c-.199.037-.398.073-.596.112-.102.612-2.214 1.423-3.562 1.912C9.489 1.536 7.376.724 7.275.112A56.108 56.108 0 0 0 6.68 0C5.876.264 2.399 2.419.207 3.554L0 3.656C.429 4.74.844 5.828 1.248 6.921a49.564 49.564 0 0 1 2.964-1.313L5.578 16a40.39 40.39 0 0 1 10.515 0c.457-3.463.912-6.928 1.367-10.392 1.009.407 1.997.845 2.964 1.313.404-1.092.82-2.18 1.248-3.265a9.665 9.665 0 0 0-.205-.102z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

ShirtIcon.propTypes = propTypes;

export default ShirtIcon;
